<shared-modal [modalTitle]="'Quarantine ' + title" [showFooter]="true">
  <div modalBody>
    <form [formGroup]="form" (ngSubmit)="setQuarantineManually()">
      <mat-radio-group class="flex flex-col flex-gap-12" [formControl]="f.type">
        @if (!isQuarantined) {
          <mat-radio-button [value]="ManualQuarantineType.ForTime">
            <span class="flex flex-gap-8 align-items--center"> For <shared-duration-picker name="quarantineDuration" [formControl]="f.duration" [showDays]="false"></shared-duration-picker> </span>
          </mat-radio-button>
          <mat-radio-button [value]="ManualQuarantineType.UntilMidnight">Until midnight</mat-radio-button>
        }
        <mat-radio-button [value]="ManualQuarantineType.UntilDateTime">
          <span class="flex flex-gap-8 align-items--center">
            Until <shared-date-time-picker [formControl]="f.time" [minDate]="minDate" [dateOutOfRangeError]="'The set expiry time has already passed.'" />
          </span>
        </mat-radio-button>
        <mat-radio-button [value]="ManualQuarantineType.Manual">
          Until I change it <shared-info-icon tooltip="The {{ entityName }} will remain in quarantine until you or one of your colleagues removes it from it." />
        </mat-radio-button>
      </mat-radio-group>
    </form>
  </div>

  <div modalFooter>
    <div class="modal-footer-buttons">
      <button type="button" class="btn btn-cancel" (click)="close()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="setQuarantineManually()" [disabled]="form.invalid">{{ !isQuarantined ? 'Apply quarantine' : 'Save' }}</button>
    </div>
  </div>
</shared-modal>
